import React from 'react';
import { Link } from 'react-router-dom';

interface KeywordRule {
  phrase: string;
  url: string;
}

const AR_RULES: KeywordRule[] = [
  { phrase: 'خدمات تصحيح البرمجيات', url: '/bug-fixing' },
  { phrase: 'تصحيح البرمجيات', url: '/bug-fixing' },
  { phrase: 'التطوير المخصص', url: '/custom-development' },
  { phrase: 'تطوير البرمجيات', url: '/custom-development' },
  { phrase: 'الخدمات السحابية', url: '/cloud-services' },
  { phrase: 'الترحيل السحابي', url: '/cloud-services' },
  { phrase: 'أتمتة مكان العمل', url: '/workplace-automation' },
  { phrase: 'أتمتة العمليات', url: '/workplace-automation' },
  { phrase: 'تحسين الأداء', url: '/performance-optimization' },
  { phrase: 'الثغرات الأمنية', url: '/security-audits' },
  { phrase: 'الفحص الأمني', url: '/security-audits' },
];

const EN_RULES: KeywordRule[] = [
  { phrase: 'professional software debugging services', url: '/bug-fixing' },
  { phrase: 'software debugging services', url: '/bug-fixing' },
  { phrase: 'debugging services', url: '/bug-fixing' },
  { phrase: 'custom software development', url: '/custom-development' },
  { phrase: 'custom development services', url: '/custom-development' },
  { phrase: 'custom development', url: '/custom-development' },
  { phrase: 'cloud migration services', url: '/cloud-services' },
  { phrase: 'cloud migration', url: '/cloud-services' },
  { phrase: 'cloud services', url: '/cloud-services' },
  { phrase: 'workplace automation', url: '/workplace-automation' },
  { phrase: 'performance optimization', url: '/performance-optimization' },
  { phrase: 'security vulnerabilities', url: '/security-audits' },
  { phrase: 'security audits', url: '/security-audits' },
];

/**
 * Links contextual keywords within text to enhance internal link authority (SEO / AEO / GEO)
 */
export function renderLinkedText(text: string, isAr: boolean): React.ReactNode {
  const rules = isAr ? AR_RULES : EN_RULES;

  // Find the first matching rule in the text
  let bestMatch: { rule: KeywordRule; index: number } | null = null;

  for (const rule of rules) {
    const idx = text.toLowerCase().indexOf(rule.phrase.toLowerCase());
    if (idx !== -1) {
      if (!bestMatch || idx < bestMatch.index) {
        bestMatch = { rule, index: idx };
      }
    }
  }

  if (!bestMatch) {
    return text;
  }

  const { rule, index } = bestMatch;
  const before = text.slice(0, index);
  const matchedText = text.slice(index, index + rule.phrase.length);
  const after = text.slice(index + rule.phrase.length);

  return (
    <>
      {before}
      <Link
        to={rule.url}
        className="text-[rgb(0,0,139)] font-semibold underline decoration-blue-300 underline-offset-4 hover:text-[rgb(0,0,180)] transition-colors"
      >
        {matchedText}
      </Link>
      {renderLinkedText(after, isAr)}
    </>
  );
}
